export default __webpack_public_path__ + "static/media/Aetna.273036a7.svg";